import { AxiosResponse } from "axios";
import { MessageResponse } from "../../guiide/ts/response/messageResponse";
import HttpStatusCode from "./httpStatusCode";

class ResponseTracker<TResponse> {
  // constructor() {
  //   this.hasResponse = false;
  // }

  constructor(response: TResponse) {
    this.hasResponse = response != null;
    this.response = response;
  }

  public response: TResponse;
  public hasResponse: boolean;
  public lastResponseCode: number | null;
  public message: string;
  public isOk: boolean;
  public trackerWillHandleFailure: boolean;
  public redirectTo: string;

  public update(responseCode: number, message?: string) {
    this.hasResponse = true;
    this.lastResponseCode = responseCode;
    this.message = message ?? "";
    this.isOk = responseCode === 200;

    if (!this.isOk) {
      const trackerHandledFailureCodes = [
        HttpStatusCode.Redirect,
        HttpStatusCode.Unauthorised
      ];
      this.trackerWillHandleFailure =
        trackerHandledFailureCodes.filter(thfc => thfc == responseCode).length >
        0;
    }
  }

  public handleFailure() {
    if (!this.trackerWillHandleFailure) {
      return;
    }

    if (this.lastResponseCode == HttpStatusCode.Unauthorised) {
      window.location.href = "/login";
    } else if (this.lastResponseCode == HttpStatusCode.Redirect) {
      window.location.href = "/logoff";
    }
  }

  public static successResponse<TResponse>(): ResponseTracker<MessageResponse> {
    const messageResponse = new MessageResponse(200, "");
    const successResponseTracker = new ResponseTracker<MessageResponse>(messageResponse);
    successResponseTracker.update(200);
    return successResponseTracker;
  }

  public static fromAxiosResponse(
    axiosResponse: AxiosResponse,
    isMvcResponse: boolean
  ): ResponseTracker<AxiosResponse> {
    const responseTracker = new ResponseTracker<AxiosResponse>(axiosResponse);

    if (isMvcResponse) {
      const guiideResponse = axiosResponse.data;
      const guiideResponseCode = guiideResponse.success === true ? 200 : 400;
      responseTracker.update(guiideResponseCode, guiideResponse.message);
    } else {
      responseTracker.update(axiosResponse.status, axiosResponse.statusText);
    }

    return responseTracker;
  }

  public static fromMessageResponse<TResponse extends MessageResponse>(
    response: TResponse
  ) {
    const responseTracker = new ResponseTracker<TResponse>(response);
    responseTracker.update(response.status, response.message);
    return responseTracker;
  }

  public static empty<TResponse>(): ResponseTracker<TResponse> {
    return new ResponseTracker<TResponse>(null);
  }

  public static asFakeOkMessageResponse(): ResponseTracker<MessageResponse> {
    const responseTracker = new ResponseTracker<MessageResponse>(new MessageResponse(HttpStatusCode.Ok, ""));
    responseTracker.isOk = true;
    return responseTracker;
  }

  public static asFakeOkAxiosResponse(): ResponseTracker<AxiosResponse> {
    const axiosResponse = {} as AxiosResponse;
    const responseTracker = new ResponseTracker<AxiosResponse>(axiosResponse);
    responseTracker.isOk = true;
    return responseTracker;
  }
}

export default ResponseTracker;
